import React from 'react';

interface FormHeaderProps {
  title?: string;
  onLogoClick?: () => void;
}

/**
 * @fileoverview Componente FormHeader reutilizable
 * @description Header común para todos los formularios con logo y título
 */

const FormHeader: React.FC<FormHeaderProps> = ({ 
  title = "SOLICITUD DE PÓLIZAS DE SEGUROS DE \"RESPONSABILIDAD CIVIL y/o ACCIDENTES\" PARA CURSOS DE FORMACIÓN",
  onLogoClick
}) => {
  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    }
  };

  return (
    <div className="form-header">
      <div className="form-logo-container">
        {onLogoClick ? (
          <a 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              handleLogoClick();
            }}
            style={{ cursor: 'pointer', textDecoration: 'none', display: 'block' }}
            aria-label="Volver al inicio"
          >
            <img src="/CG-Gestion-Logo-H.png" alt="Logo" />
          </a>
        ) : (
          <img src="/CG-Gestion-Logo-H.png" alt="Logo" />
        )}
      </div>
      <h1 className="form-title">
        {title}
      </h1>
    </div>
  );
};

export default FormHeader;
